<template>
	<div class="promo-phase2">
		<div class="container">
			<div class="row">
				<div class="col-md-7" />
				<div class="col-md-5">
					<div class="promo-phase2__content">
						<h2 class="promo-phase2__discount text-uppercase">
							<span>Get your H510</span> on us with any build
						</h2>
						<a href="https://promo.nzxt.com/holiday-celebration" class="promo-phase2__button">
							See details
						</a>
						<hr class="promo-phase2__separator">
						<div class="promo-phase2__counter">
							<p class="promo-phase2__counter__heading">
								Gift Offer Ends
							</p>
							<promo-countdown
								:current-phase="currentPhase"
								:phases="phases"
								:time-zone="timeZone"
							/>
							<p class="promo-phase2__end">
								{{ shippingCopy }}
							</p>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import PromoCountdown from "@c/generals/promo-countdown";

export default {
	name: "AnnualSale2020Hero2",
	components: {
		PromoCountdown
	},
	props: {
		currentPhase: {
			type: [String, Number],
			required: true
		},
		phases: {
			type: [Object, Array],
			default() {
				return [];
			}
		},
		timeZone: {
			type: String,
			default: "America/Los_Angeles"
		}
	},
	computed:{
		shippingCopy() {
			return [
				"*Offer ends 12/31 @ 11:59pm PST."
			][this.currentPhase];
		}
	}
};
</script>

<style lang="scss">
@import "~@s/_asset-mixers.scss";

.promo-phase2 {
	.countdown, .countdown__time__description {
		color: $oldpurple !important;
	}

	.countdown__time__description {
		font-family: 'Akkurat-Normal' !important;
	}
}

</style>

<style lang="scss" scoped>
@import "~@s/_asset-mixers.scss";

.promo-phase2 {
	margin-left: -15px;
	margin-right: -15px;
	padding: 120px 0 130px;
	color: $oldpurple;
	background-color: #000;
	background-repeat: no-repeat;
	background-image: url('/images/promo-sales/christmas-2020/christmas-2020-hero-2x.jpg');
	background-size: cover;
	background-position: center;

	@media screen and (min-width: 991px) and (max-width: 1200px) {
		background-position: 40%;
	}

	@media (max-width: 991px) {
		background-image: url('/images/promo-sales/christmas-2020/christmas-2020-hero-mobile-2x.jpg');
	}

	@media screen and (min-width: 500px) and (max-width: 991px) {
		background-position: initial;
		padding: 90% 0 70px;
	}

	@media screen and (max-width: 500px) {
		padding: 360px 0 20px;
		background-position: initial;
	}

	&__separator {
		display: block;
		border-top-color: #B999CA;
		height: 1px;
		width: 100%;
		opacity: 1;
		margin: 0 0 40px;
	}

	&__img {

		@media screen and (min-width: 767px) and (max-width: 991px) {
			margin: 0 auto;
			max-width: 500px;
		}

		img {
			width: 100%;
		}
	}

	&__content {
		max-width: 400px;
		margin: 0 auto;

		@media screen and (min-width: 768px) and (max-width: 991px) {
			margin: 0 auto;
			max-width: 65%;
		}

		@media screen and (max-width: 768px) {
			padding-top: 0;
		}
	}

	&__heading {
		font-family: Akkurat-Light;
		font-size: 23px;
		font-weight: 300;
		letter-spacing: 1.13px;
		text-align: center;
		margin: 0 0 20px;

		@media screen and (max-width: 580px) {
			margin: 20px 0;
			padding: 0;
		}

		@media screen and (min-width: 991px) and (max-width: 1200px) {
			font-size: 18px;
		}
	}

	&__discount {
		font-size: 32px;
		letter-spacing: 2px;
		text-align: center;
		line-height: 45px;

		@media screen and (min-width: 991px) and (max-width: 1200px) {
			font-size: 26px;
		}

		@media screen and (max-width: 580px) {
			font-size: 24px;
			font-weight: 300;
			letter-spacing: 1.5px;
			margin: 25px 0 15px;
			line-height: 39px;
		}

		span {
			display: block;
			font-size: 54px;
			letter-spacing: 0;

			@media screen and (min-width: 991px) and (max-width: 1200px) {
				font-size: 51px;
			}

			@media screen and (max-width: 580px) {
				font-size: 44px;
				font-family: 'Akkurat-Normal';
			}
		}
	}

	&__button {
		display: block;
		text-align: center;
		width: 100%;
		border-radius: 5px;
		background-color: $oldpurple;
		color: $white;
		margin-bottom: 50px;
		padding: 17px 0;
		font-size: 14px;
		text-transform: uppercase;
		transition: all .2s;
		border: solid 2px transparent;

		@media screen and (max-width: 768px) {
			margin-bottom: 30px;
		}

		&:hover {
			color: $oldpurple;
			border: solid 2px $oldpurple;
			background-color: transparent;
			font-weight: bold;

			@media screen and (max-width: 768px) {
				margin-bottom: 8px;
			}
		}
	}

	&__counter {

		&__heading {
			font-weight: 300;
			text-align: center;
			text-transform: uppercase;
			margin-top: 25px;
			margin-bottom: -10px;
			font-size: 17px;
			letter-spacing: 0.8px;

			@media (max-width: 1200px) {
				font-size: 16px;
			}
		}
	}

	&__end {
		opacity: 0.8;
		font-size: 12px;
		text-align: center;
	}
}

.promo-phase2 {
	@media screen and (max-width: 580px) {

		.annual-sales-banner__content {
			margin: 0 auto !important;
		}

		.annual-sales-banner__heading {
			margin: 0 0 20px !important;
		}
	}
}
</style>
